import script from "./BlogCatalogCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./BlogCatalogCard.vue?vue&type=script&lang=ts&setup=true"

import "./BlogCatalogCard.vue?vue&type=style&index=0&id=fd31c19a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fd31c19a"]])

export default __exports__